import { FC } from 'react'
import { useSelector } from 'react-redux'
import { RootStoreState, AppManifest } from 'mytours-read-common'
import { Helmet } from 'react-helmet'
import { ionHistory } from 'mobile_web/modules/navigation'
import { getProfileUrl } from 'mobile_web/modules/navigation/routes'
import strings from '../../../strings'
import AudioPlayerBarComponent from 'mobile_web/modules/audio/components/AudioPlayerBar'
import Page from '../../common/components/Page'
import FavouriteGroupBlock from './FavouriteGroupBlock'
import '../style.less'
import { RouteComponentProps } from 'react-router'

const Favourites: FC<RouteComponentProps> = () => {
	const appManifest = useSelector((state: RootStoreState) => state.settings.appManifest) as AppManifest

	const handleGoProfile = () => {
		ionHistory.replace(getProfileUrl())
	}

	return (
		<>
			<Helmet
				title={strings.favourites}
				meta={[
					{ name: 'description', content: strings.favourites },
					{ property: 'og:type', content: 'website' },
					{ property: 'og:title', content: strings.favourites },
					{ property: 'og:description', content: strings.favourites },
					{ property: 'og:url', content: window.location.href },
				]}
			/>
			<Page
				contentProps={{
					className: 'profile-content',
				}}
				headerProps={{
					title: strings.favourites,
					hideBackButton: true,
					withBgColor: false,
					buttonTextShadow: false,
					showBackButton: true,
					backButtonLabel: strings.profile,
					className: 'favourites-header',
					onBackButton: handleGoProfile,

					collectionItem: null,
					itemType: null,
					itemId: null,
					collection: null,
					screen: null,
					hideFavouriteButton: true,
				}}
				footer={{
					component: <AudioPlayerBarComponent bottomOffset={-1} />,
				}}
				dataCy="page-favourites"
			>
				{appManifest.favorites_enabled ? <FavouriteGroupBlock appManifest={appManifest} /> : null}
			</Page>
		</>
	)
}

export default Favourites
